import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import type { GeneralSettings } from '../types/learning-experience.types'

/** Opt-out: all three default to `true`. */
const DEFAULT_GENERAL_SETTINGS: Required<GeneralSettings> = {
  autoCompleteOn50Percent: true,
  autoPlayNextLesson: true,
  autoPlayFirstLesson: true,
}

type ProductWithGeneralSettings = { customizations?: { generalSettings?: GeneralSettings } | null } | null | undefined

/** Reads `customizations.generalSettings`; missing fields use defaults. */
export const useLearningExperience = (product: MaybeRefOrGetter<ProductWithGeneralSettings>) => {
  const generalSettings = computed<Required<GeneralSettings>>(() => {
    const raw = toValue(product)?.customizations?.generalSettings
    return {
      autoCompleteOn50Percent: raw?.autoCompleteOn50Percent ?? DEFAULT_GENERAL_SETTINGS.autoCompleteOn50Percent,
      autoPlayNextLesson: raw?.autoPlayNextLesson ?? DEFAULT_GENERAL_SETTINGS.autoPlayNextLesson,
      autoPlayFirstLesson: raw?.autoPlayFirstLesson ?? DEFAULT_GENERAL_SETTINGS.autoPlayFirstLesson,
    }
  })

  const autoCompleteOn50Percent = computed(() => generalSettings.value.autoCompleteOn50Percent)
  const autoPlayNextLesson = computed(() => generalSettings.value.autoPlayNextLesson)
  const autoPlayFirstLesson = computed(() => generalSettings.value.autoPlayFirstLesson)

  return {
    generalSettings,
    autoCompleteOn50Percent,
    autoPlayNextLesson,
    autoPlayFirstLesson,
  }
}
